import { render, staticRenderFns } from "./CustomerOrders.vue?vue&type=template&id=3147680c&scoped=true&"
import script from "./CustomerOrders.vue?vue&type=script&lang=js&"
export * from "./CustomerOrders.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrders.vue?vue&type=style&index=0&id=3147680c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3147680c",
  null
  
)

export default component.exports